import { render, staticRenderFns } from "./FormMailingAddressQuestionSettings.vue?vue&type=template&id=038c3d9f"
import script from "./FormMailingAddressQuestionSettings.vue?vue&type=script&lang=js"
export * from "./FormMailingAddressQuestionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports